module.exports = __webpack_public_path__ + "assets/img/img307.5b7457a6.png";